// extracted by mini-css-extract-plugin
export default {"desde":"TablaPersonaClubes_desde__25WwC","hasta":"TablaPersonaClubes_hasta__eEFYW","club":"TablaPersonaClubes_club__k5dg7"};